<template lang="pug">
div(:style="{ flex: `0 0 ${vSize}`, marginTop }").gap
</template>

<script>
import _ from 'lodash'

export default {
  name: 'PageGap',
  props: {
    size: { type: [String, Number], default: 1.5 },
    marginTop: { type: String, default: '0' },
  },
  data() {
    return {}
  },
  computed: {
    vSize() {
      if (_.isNumber(this.size)) {
        return `${this.size}em`
      }
      return this.size
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {},
  },
}
</script>

<style lang="scss" scoped></style>
